import { type PropsWithChildren } from "react";
import { Menu, MenuItem, PopoverPosition } from "@mui/material";

interface ContextMenuProps extends PropsWithChildren {
  open: boolean;
  onClose: () => void;
  anchorPosition?: PopoverPosition;
}

function ContextMenuRoot({ open, onClose, anchorPosition, children }: ContextMenuProps) {
  return (
    <Menu
      open={open}
      onClose={onClose}
      anchorReference="anchorPosition"
      anchorPosition={anchorPosition}
      PaperProps={{
        sx: {
          minWidth: 220,
          borderRadius: 2,
          boxShadow: 3,
        },
      }}
      MenuListProps={{
        disablePadding: true,
        sx: {
          p: 1,
          "&:focus, &:focus-visible": {
            outline: "none",
          },
        },
      }}
    >
      {children}
    </Menu>
  );
}

function ContextMenuItem({ onClick, children }: PropsWithChildren<{ onClick?: () => void }>) {
  return (
    <MenuItem
      onClick={onClick}
      sx={{
        p: "10px 12px",
        borderRadius: 1,
        color: "text.primary",
        fontSize: "14px",
        fontWeight: 400,
        outline: "none",
        "&:hover": {
          backgroundColor: "action.hover",
        },
        "&:focus, &:focus-visible": {
          outline: "none",
          boxShadow: "none",
        },
      }}
    >
      {children}
    </MenuItem>
  );
}

export const ContextMenu = Object.assign(ContextMenuRoot, { Item: ContextMenuItem });
